import React, { useState } from 'react';
import { ArrowUpRightIcon, ExternalLinkIcon } from 'lucide-react';
import { bonuses } from '../data/bonuses';
import { BONUS_IMAGES } from '../data/images';
import { toThumb, toView } from '../data/links';
import { SectionHeading } from './SectionHeading';
const pad = (value: number) => String(value).padStart(2, '0');
export function BonusStack() {
  /* An image host we do not own can stop answering. If one does, that card
     quietly falls back to the typeset panel instead of a broken image. */
  const [broken, setBroken] = useState<Record<string, boolean>>({});
  return <section aria-label="Your bonus activity packs" id="bonus" className="scroll-mt-24" data-id="element-46" data-mp="3f1d14fm17usi">
      <SectionHeading index="03" title="Your bonus activity packs" note="Eight printable packs that came with your order. None of them are printed in the books, and they do not expire." data-id="element-47" data-mp="3jscxnjr8oauh">
        <span className="inline-flex items-center rounded-full bg-mist px-3 py-1.5 font-sans text-[11px] font-semibold tracking-[0.12em] text-navy" data-id="element-48" data-mp="2rbipu2hd2ead">
          ALL {bonuses.length} UNLOCKED
        </span>
      </SectionHeading>

      <ul className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-49" data-mp="3nc8niopn7qpz">
        {bonuses.map(bonus => {
        const href = bonus.own ? toView(bonus.href) : bonus.href;
        const key = bonus.img;
        const source = BONUS_IMAGES[key] || (bonus.own ? toThumb(bonus.href, 480) : '');
        const img = broken[key] ? '' : source;
        return <li key={bonus.n} className="flex flex-col gap-4 rounded-[18px] border border-navy/10 bg-white p-4 sm:flex-row sm:p-5" data-id="element-50" data-mp="34lh6d0zeyw11">
              <div className="h-[132px] w-full shrink-0 overflow-hidden rounded-[12px] bg-navy sm:h-[124px] sm:w-[132px]" data-id="element-51" data-mp="2zo8ney6fynyq">
                {img ? <img src={img} alt="" aria-hidden="true" loading="lazy" onError={() => setBroken(prev => ({
              ...prev,
              [key]: true
            }))} className="h-full w-full object-cover" data-id="element-52" data-mp="xv15dgzg1s95" /> : <div aria-hidden="true" className="flex h-full w-full items-end justify-between p-3" data-id="element-53" data-mp="2s3y3d1ku04sh">
                    <span className="font-display text-[34px] font-semibold leading-none text-sun" data-id="element-54" data-mp="2idv80uq8meqz">
                      {pad(bonus.n)}
                    </span>
                    <span className="pb-1 font-sans text-[9px] font-semibold uppercase tracking-[0.16em] text-paper/60" data-id="element-55" data-mp="3b1heqburhzi2">
                      Bonus
                    </span>
                  </div>}
              </div>

              <div className="flex min-w-0 flex-1 flex-col" data-id="element-56" data-mp="312a1rprxw6vh">
                <div className="flex items-baseline justify-between gap-3" data-id="element-57" data-mp="1kp1q14kd3coh">
                  <p className="tnum font-sans text-[10.5px] font-semibold tracking-[0.16em] text-[#B07E00]" data-id="element-58" data-mp="1kr61q8oi5fzb">
                    BONUS {pad(bonus.n)}
                  </p>
                  <p className="tnum font-sans text-[11px] text-navy/40" data-id="element-59" data-mp="7oyf4atnplmu">{bonus.volume}</p>
                </div>

                <h3 className="mt-1.5 font-display text-[18px] font-semibold leading-snug text-navy" data-id="element-60" data-mp="2r6pxokecdmc">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-[14px] leading-relaxed text-navy/65" data-id="element-61" data-mp="cpcp3yetj5ni">
                  {bonus.blurb}
                </p>

                <div className="mt-auto pt-4" data-id="element-62" data-mp="3l5nxyysoyb77">
                  {href ? <a href={href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-[12px] bg-navy px-4 py-2.5 font-sans text-[13px] font-medium text-paper transition-colors duration-150 ease-out hover:bg-[#0A2440] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-63" data-mp="3g7mfaez6gdw9">
                      {bonus.own ? <ExternalLinkIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2} data-id="element-64" data-mp="3a2zs1lv5al85" /> : <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={2} data-id="element-65" data-mp="3k3ifsrptylvc" />}
                      {bonus.own ? 'Open bonus' : 'Open pack'}
                    </a> : <span className="inline-flex items-center rounded-[12px] border border-navy/15 px-4 py-2.5 font-sans text-[13px] text-navy/35" data-id="element-66" data-mp="3ts0g77u76qyg">
                      Link not set
                    </span>}
                </div>
              </div>
            </li>;
      })}
      </ul>
    </section>;
}